module.exports = __webpack_public_path__ + "img/text_04.37a6b9a7.png";